import gql from 'graphql-tag';

export default gql`
  mutation addFeaturedCollection(
    $id: ID!
  ) {
    addFeaturedCollection(
      id: $id
    ) {
      id
      name
    }
  }
`;
